import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'cookie-consent';

type ConsentType = 'all' | 'necessary' | null;

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (
      !consent ||
      (consent === 'all' &&
        !localStorage.getItem('newsletter-analytics-consent'))
    ) {
      setShowBanner(true);
    }
    const reopen = () => setShowBanner(true);
    window.addEventListener('newsletter-consent-reset', reopen);
    return () => window.removeEventListener('newsletter-consent-reset', reopen);
  }, []);

  const handleAccept = (type: 'all' | 'necessary') => {
    localStorage.setItem(COOKIE_CONSENT_KEY, type);
    localStorage.setItem('newsletter-analytics-consent', type);
    window.dispatchEvent(new Event('newsletter-consent-change'));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      data-testid="cookie-banner"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(10,10,11,0.98)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        padding: '20px 24px',
        zIndex: 9999,
        backdropFilter: 'blur(20px)',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 24,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ flex: 1, minWidth: 280 }}>
          <p
            style={{
              fontSize: 14,
              color: 'rgba(232,230,225,0.8)',
              lineHeight: 1.6,
              margin: 0,
            }}
          >
            Utilizziamo memorie tecniche per il sito. Con «Accetta tutti»
            autorizzi anche il conteggio delle visualizzazioni di Segnali AI e
            dei clic sulle fonti. Puoi continuare con «Solo necessari» e
            cambiare scelta nella Cookie Policy. Per maggiori informazioni,
            consulta la nostra
            <Link
              to="/cookie-policy"
              style={{ color: '#3B82F6', textDecoration: 'underline' }}
            >
              Cookie Policy
            </Link>
            .
          </p>
        </div>
        <div style={{ display: 'flex', gap: 12, flexShrink: 0 }}>
          <button
            onClick={() => handleAccept('necessary')}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: '1px solid rgba(255,255,255,0.2)',
              background: 'transparent',
              color: 'rgba(232,230,225,0.7)',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
          >
            Solo necessari
          </button>
          <button
            onClick={() => handleAccept('all')}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              background: '#3B82F6',
              color: 'white',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}

export function getCookieConsent(): ConsentType {
  return localStorage.getItem(COOKIE_CONSENT_KEY) as ConsentType;
}
